<template>
  <div>
    <a-modal v-model:open="open" :width="modalWidth" :closable="false" @ok="handleOk">
      <template #title>
        <div class="flex aic jcsb">
          <div class="modal_title">{{ modalTitle }}</div>
          <div class="out" @click="handleCancelClose">
            <CloseOutlined />
          </div>
        </div>
      </template>
      <div class="modal_content">
        <slot></slot>
      </div>
      <template v-if="!confirmFlag" #footer>
        <div v-if="isDetailStatus" style="margin-bottom: 39px">
          <a-button key="back" type="primary" ghost @click="handleCancel">取消</a-button>
          <a-button :disabled="confirmDisabled" class="ml61" key="submit" type="primary" @click="handleOk">确定</a-button>
        </div>
      </template>
      <template v-if="confirmFlag" #footer>
        <div v-if="isDetailStatus" style="margin-bottom: 39px">
          <a-button key="back" type="primary" ghost @click="handleCancel">拒绝</a-button>
          <a-button class="ml61" key="submit" type="primary" @click="handleOk">同意</a-button>
        </div>
      </template>
    </a-modal>
  </div>
</template>
<script setup>
import {
  ref,
  reactive,
  toRefs,
  onBeforeMount,
  onMounted,
  defineProps,
  defineEmits,
  defineExpose,
} from "vue";

const props = defineProps({
  modalWidth: {
    type: String,
    default: () => "582px",
  },
  modalTitle: {
    type: String,
    default: () => "审批",
  },
  isDetailStatus: {
    type: Boolean,
    default: false,
  },
  // 评估报告的 确认和取消 不一样 需要区分
  confirmFlag: {
    type: Boolean,
    default: false,
  },
  // 评估报告的 确认需要加判断
  confirmDisabled: {
    type: Boolean,
    default: false,
  },
  
});

const open = ref(false);
const showModal = () => {
  open.value = true;
};
const hideModal = () => {
  open.value = false;
};

const emit = defineEmits(["saveEvent", "cancelEvent"]);

const handleOk = (e) => {
  console.log(e);
  open.value = false;
  emit("saveEvent");
};
const handleCancel = () => {
  open.value = false;
  emit("cancelEvent");
};
const handleCancelClose = () => {
  open.value = false;
};

defineExpose({
  showModal,
  hideModal,
  open
});
</script>
<style lang="less" scoped>
.modal_title {
  font-size: 18px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  color: #1d2129;
}

.out {
  cursor: pointer;
  font-size: 18px;
  color: #636d7b;
  border-radius: 1px 1px 1px 1px;
}

.ml61 {
  margin-left: 61px !important;
}
</style>
